import Login from '@/pages/Login';
import Main from '@/pages/Main';

import Profile from '@/pages/ProfileManager/Profile';
import ChangePassword from '@/pages/ProfileManager/ChangePassword';
import ForgotPass from '@/pages/ProfileManager/ForgotPass';
import ResetPassword from '@/pages/ProfileManager/ResetPassword';

import StaffManagement from '@/pages/StaffManager/StaffManagement';
import ApproveStaffManagement from '@/pages/StaffManager/ApproveStaffManagement';
import CreatedStaffManagement from '@/pages/StaffManager/CreatedStaffManagement';
import RetireStaffManagement from '@/pages/StaffManager/RetireStaffManagement';
import ReportManagement from '@/pages/StaffManager/ReportManagement';

import BlockManagement from '@/pages/ContextManager/BlockManagement';
import DepartmentManagement from '@/pages/ContextManager/DepartmentManagement';
import TeamManagement from '@/pages/ContextManager/TeamManagement';

import CategoryManagement from '@/pages/PermissionManager/CategoryManagement';
import PermissionManagement from '@/pages/PermissionManager/PermissionManagement';
import PermissionAssign from '@/pages/PermissionManager/PermissionAssign';
import JobManagement from '@/pages/PermissionManager/JobManagement';

import CustomerManagement from '@/pages/CustomerManager/CustomerManagement';
import CustomerType from '@/pages/CustomerManager/CustomerType';
import OrderUnitManagement from '@/pages/Target/OrderUnitManagement';

import FormStyleManagement from '@/pages/MaterialManager/FormStyleManagement';
import MaterialManagement from '@/pages/MaterialManager/MaterialManagement';
import MaterialStyleManagement from '@/pages/MaterialManager/MaterialStyleManagement';
import MetricManagement from '@/pages/MaterialManager/MetricManagement';
import PrintStyleManagment from '@/pages/MaterialManager/PrintStyleManagment';
import OrderTypeManagement from '@/pages/MaterialManager/OrderTypeManagement';
import ProfileManagement from '@/pages/MaterialManager/ProfileManagement';
import SizeManagement from '@/pages/MaterialManager/SizeManagement';

import GiftManagement from '@/pages/GiftManager/GiftManagement';

import DesignRequestManagement from '@/pages/Sale/DesignRequestManagement';
import CreateDesignRequest from '@/pages/Sale/CreateDesignRequest';
import CreateManufactureRequest from '@/pages/Sale/CreateManufactureRequest';
import ManufactureRequestManagement from '@/pages/Sale/ManufactureRequestManagement';
import ProcessingRequestManagement from '@/pages/Sale/ProcessingRequestManagement';
import FinishRequestManagement from '@/pages/Sale/FinishRequestManagement';
import TemplateCatalog from '@/pages/Sale/TemplateCatalog';

import DesignerDesignRequest from '@/pages/Designer/DesignerDesignRequest';
import DesignerManufactureRequest from '@/pages/Designer/DesignerManufactureRequest';
import DesignerProcessingRequest from '@/pages/Designer/DesignerProcessingRequest';
import DesignerFinishedRequest from '@/pages/Designer/DesignerFinishedRequest';

import AccountantFinishRequest from '@/pages/Accountant/AccountantFinishRequest';
import AccountantManufactureRequest from '@/pages/Accountant/AccountantManufactureRequest';
import AccountantProcessingRequest from '@/pages/Accountant/AccountantProcessingRequest';
import AccountantPendingRequest from '@/pages/Accountant/AccountantPendingRequest';

import DesignRequestStatistic from '@/pages/Statistics/DesignRequestStatistic';
import MaterialStatistic from '@/pages/Statistics/MaterialStatistic';
import ProfitStatistic from '@/pages/Statistics/ProfitStatistic';
import DesignerScoreStatistic from '@/pages/Statistics/DesignerScoreStatistic';

import SystemSetting from '@/pages/Settings/SystemSetting';
import LogisticUnitManagement from '@/pages/Logistic/LogisticUnitManagement';
import LogisticRequestManagement from '@/pages/Logistic/LogisticRequestManagement';

import IdeaCategory from '@/pages/Idea/IdeaCategory';
import IdeaRequestApprove from '@/pages/Idea/IdeaRequestApprove';
import IdeaRequestManagement from '@/pages/Idea/IdeaRequestManagement';

import NotificationManagement from '@/pages/Notification/NotificationManagement';

import DepartmentsAssign from '@/pages/LocationAssign/DepartmentsAssign';
import TeamAssign from '@/pages/LocationAssign/TeamAssign';
import StaffAssign from '@/pages/LocationAssign/StaffAssign';

import ContactManagement from '@/pages/Contact/ContactManagement';
import CompetitorManagement from '@/pages/Contact/CompetitorManagement';

import TargetManagement from '@/pages/Target/TargetManagement';
import ApproveTargetManagement from '@/pages/Target/ApproveTargetManagement';


const routes = [
    {path: '/login', name: 'login', component: Login, meta: {requireLogin: false}},
    {path: '/forgot', name: 'forgot', component: ForgotPass, meta: {requireLogin: false}},
    {path: '/reset/:token', name: 'reset', component: ResetPassword, meta: {requireLogin: false}},
    {
        path: '/', name: 'main', component: Main, children: [
            {path: '/profile', name: 'profile', component: Profile},
            {path: '/changePass', name: 'changePass', component: ChangePassword},

            {path: '/blockManagement', name: 'blockManagement', component: BlockManagement},
            {path: '/departmentManagement', name: 'departmentManagement', component: DepartmentManagement},
            {path: '/teamManagement', name: 'teamManagement', component: TeamManagement},

            {path: '/categoryManagement', name: 'categoryManagement', component: CategoryManagement},
            {path: '/permissionManagement', name: 'permissionManagement', component: PermissionManagement},
            {path: '/permissionAssign', name: 'permissionAssign', component: PermissionAssign},
            {path: '/jobManagement', name: 'jobManagement', component: JobManagement},

            {path: '/staffManagement', name: 'staffManagement', component: StaffManagement},
            {path: '/createdStaffManagement', name: 'createdStaffManagement', component: CreatedStaffManagement},
            {path: '/approveStaffManagement', name: 'approveStaffManagement', component: ApproveStaffManagement},
            {path: '/retireStaffManagement', name: 'retireStaffManagement', component: RetireStaffManagement},
            {path: '/reportManagement', name: 'reportManagement', component: ReportManagement},

            {path: '/customerManagement', name: 'customerManagement', component: CustomerManagement},
            {path: '/customerType', name: 'customerType', component: CustomerType},

            {path: '/ideaCategory', name: 'ideaCategory', component: IdeaCategory},
            {path: '/ideaRequestApprove', name: 'ideaRequestApprove', component: IdeaRequestApprove},
            {path: '/ideaRequestManagement', name: 'ideaRequestManagement', component: IdeaRequestManagement},

            {path: '/formStyleManagement', name: 'formStyleManagement', component: FormStyleManagement},
            {path: '/materialManagement', name: 'materialManagement', component: MaterialManagement},
            {path: '/materialStyleManagement', name: 'materialStyleManagement', component: MaterialStyleManagement},
            {path: '/metricManagement', name: 'metricManagement', component: MetricManagement},
            {path: '/printStyleManagment', name: 'printStyleManagment', component: PrintStyleManagment},
            {path: '/orderTypeManagement', name: 'orderTypeManagement', component: OrderTypeManagement},
            {path: '/profileManagement', name: 'profileManagement', component: ProfileManagement},
            {path: '/sizeManagement', name: 'sizeManagement', component: SizeManagement},

            {path: '/logisticUnitManagement', name: 'logisticUnitManagement', component: LogisticUnitManagement},
            {
                path: '/logisticRequestManagement',
                name: 'logisticRequestManagement',
                component: LogisticRequestManagement
            },

            {path: '/giftManagement', name: 'giftManagement', component: GiftManagement},
            {path: '/designRequestManagement', name: 'designRequestManagement', component: DesignRequestManagement},
            {path: '/createDesignRequest', name: 'createDesignRequest', component: CreateDesignRequest},
            {path: '/createManufactureRequest', name: 'createManufactureRequest', component: CreateManufactureRequest},
            {
                path: '/manufactureRequestManagement',
                name: 'manufactureRequestManagement',
                component: ManufactureRequestManagement
            },
            {
                path: '/processingRequestManagement',
                name: 'processingRequestManagement',
                component: ProcessingRequestManagement
            },
            {path: '/finishRequestManagement', name: 'finishRequestManagement', component: FinishRequestManagement},
            {path: '/templateCatalog', name: 'templateCatalog', component: TemplateCatalog},

            {path: '/designerDesignRequest', name: 'designerDesignRequest', component: DesignerDesignRequest},
            {
                path: '/designerManufactureRequest',
                name: 'designerManufactureRequest',
                component: DesignerManufactureRequest
            },
            {
                path: '/designerProcessingRequest',
                name: 'designerProcessingRequest',
                component: DesignerProcessingRequest
            },
            {path: '/designerFinishedRequest', name: 'designerFinishedRequest', component: DesignerFinishedRequest},

            {path: '/accountantFinishRequest', name: 'accountantFinishRequest', component: AccountantFinishRequest},
            {
                path: '/accountantManufactureRequest',
                name: 'accountantManufactureRequest',
                component: AccountantManufactureRequest
            },
            {
                path: '/accountantProcessingRequest',
                name: 'accountantProcessingRequest',
                component: AccountantProcessingRequest
            },
            {path: '/accountantPendingRequest', name: 'accountantPendingRequest', component: AccountantPendingRequest},

            {path: '/designRequestStatistic', name: 'designRequestStatistic', component: DesignRequestStatistic},
            {path: '/materialStatistic', name: 'materialStatistic', component: MaterialStatistic},
            {path: '/profitStatistic', name: 'profitStatistic', component: ProfitStatistic},
            {path: '/designerScoreStatistic', name: 'designerScoreStatistic', component: DesignerScoreStatistic},
            {path: '/systemSetting', name: 'systemSetting', component: SystemSetting},

            {path: '/notificationManagement', name: 'notificationManagement', component: NotificationManagement},

            {path: '/DepartmentsAssign', name: 'departmentsAssign', component: DepartmentsAssign},
            {path: '/TeamAssign', name: 'teamAssign', component: TeamAssign},
            {path: '/StaffAssign', name: 'staffAssign', component: StaffAssign},

            {path: '/ContactManagement', name: 'contactManagement', component: ContactManagement},
            {path: '/CompetitorManagement', name: 'competitorManagement', component: CompetitorManagement},

            {path: '/orderUnitManagement', name: 'orderUnitManagement', component: OrderUnitManagement},
            {path: '/TargetManagement', name: 'targetManagement', component: TargetManagement},
            {path: '/ApproveTargetManagement', name: 'approveTargetManagement', component: ApproveTargetManagement}
        ]
    },


];

export default routes;